import scene from './scene.module'
export default scene
